export const eautomateKeys = {
  connections: (entityId: string) =>
    ['eautomate', 'connections', entityId] as const,
  agents: (entityId: string) => ['eautomate', 'agents', entityId] as const,
}
